<div class="col-12 p-5">
    <div class="row">
        <div *ngFor="let group of groups" class="col-4 p-2">
            <div class="group-card p-4">
                <div>
                    <h5>{{group.title}}</h5>
                    <div class="divider"></div>
                    <p>{{group.description}}</p>
                    <p (click)="selectedInfo = group.info" data-target=".info-modal" data-toggle="modal" class="view-more" (click)="updateEditor('.description-editor', group.info)">Ver más</p>

                </div>
                
                <div>
                    
                    <h6> <i class="fa fa-check"></i> {{group.testsQuantity}} Pruebas</h6>
                    <div class="divider"></div>
                    <h6> <i class="fa fa-check"></i> {{group.questionsQuantity}} Preguntas</h6>
                    <div class="divider"></div>
                    <button class="btn btn-primary btn-rounded w-100 mt-3" (click)="handleTestClick()" >{{user?.canUseCustomTests ? 'Ir' : 'Suscribirme'}}</button>
                </div>


            </div>
        </div>
    </div>
</div>

<div class="modal fade info-modal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" style="display: none;">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="form-group ">
                    <div class="col-12">
                        <div class="description-editor"></div>

                    </div>
                </div> 
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>